/** @jsx jsx */
import { jsx, Box, Flex, Styled } from "theme-ui"
import PropTypes from "prop-types"

import { Container, Row, Col } from "components/layout"

import useLocales from "hooks/use-locales"

const Infographic = ({ Icon, current, previous, children }) => {
  const { t } = useLocales()
  return (
    <Box sx={{ bg: "primary", color: "background", py: 5, my: 5 }}>
      <Container>
        <Row
          sx={{ flexDirection: ["column", "row"], alignItems: "flex-start" }}
        >
          <Col sx={{ width: ["100%", "50%"] }}>
            <Flex
              sx={{ alignItems: "center", flexDirection: ["column", "row"] }}
            >
              <Icon
                sx={{ width: ["100%", "70%"], height: "auto", mr: [3, 4] }}
              />
              <Box
                sx={{
                  borderRight: ["none", "medium solid"],
                  borderRightColor: "background",
                }}
              >
                <Box sx={{ pr: [0, 4] }}>
                  <Styled.h2
                    as="p"
                    sx={{ color: "background", fontWeight: "normal" }}
                  >
                    <span sx={{ mb: 3, display: "block", fontWeight: 600 }}>
                      {current}
                    </span>
                    {children}
                  </Styled.h2>
                </Box>
              </Box>
            </Flex>
          </Col>
          <Col sx={{ width: ["100%", "50%"] }}>
            <Box sx={{ pl: [0, 4] }}>
              <Styled.h2
                as="p"
                sx={{ color: "background", fontWeight: "normal" }}
              >
                <span sx={{ mb: 3, display: "block", fontWeight: 600 }}>
                  {previous}
                </span>
                {t("previous")}
              </Styled.h2>
            </Box>
          </Col>
        </Row>
      </Container>
    </Box>
  )
}
Infographic.propTypes = {
  Icon: PropTypes.any.isRequired,
  current: PropTypes.string.isRequired,
  previous: PropTypes.string.isRequired,
  children: PropTypes.any,
}

export default Infographic
